module.exports = __webpack_public_path__ + "img/fsbd.627a870a.gif";